<template>
  <div class="qr-login-container">
    <div class="box">
      <van-divider :style="{ color: '#12A83C', borderColor: '#12A83C', padding: '0 16px' }">小程序授权登录</van-divider>
      <div id="qrCode" ref="qrCodeDiv" class="qr-code"/>
      <van-notice-bar :scrollable="false" wrapable left-icon="info-o" class="tips">请打开【亲小禾】小程序进入首页并切换至【老师角色】，点击右上角扫一扫授权登录！</van-notice-bar>
    </div>
  </div>
</template>

<script>
import { api } from '@/api/index'
import QRCode from 'qrcodejs2'
import { Divider, NoticeBar } from 'vant'

export default {
  name: 'QrLogin',
  components: {
    [Divider.name]: Divider,
    [NoticeBar.name]: NoticeBar
  },
  data() {
    return {
      qrTicket: '',
      timer: null
    }
  },
  created() {
    if (this.$store.getters.isLogin) {
      this.$router.push("/courseList")
      return
    }
    this.getTicket()
  },
  methods: {
    getTicket() {
      api.getUserLoginTicket().then(res => {
        if (res.code === 10000) {
          this.qrTicket = res.data.qrTicket
          this.createQrLogin()
          this.timer = setInterval(() => {
            this.login()
          }, 1000)
        }
      })
    },
    createQrLogin() {
      setTimeout(() => {
        new QRCode('qrCode', {
          width: 200,
          height: 200,
          text: 'https://applet.xiaohebook.com?source=scanLogin&qrTicket=' + this.qrTicket
        })
      })
    },
    login() {
      api.pollingUserLogin({
        qrTicket: this.qrTicket
      }).then(res => {
        if (res.code === 10000) {
          clearInterval(this.timer)
          this.$toast.success('登录成功')
          setTimeout(() => {
            // 修改登陆状态
            this.$store.commit("SET_LOGIN", true)
            // 把用户名存入store
            this.$store.commit("SET_ACCOUNT_INFO", res.data)
            this.$router.push("/courseList")
          }, 1000)
        }
      }).catch(err => {
        console.log(err.message)
      })
    }
  }
}
</script>

<style scoped>
.qr-login-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 400px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 0 8px rgba(0, 0, 0, .2);
}

.qr-code {
  position: absolute;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
}

.tips{
  position: absolute;
  width: 100%;
  top: 310px;
  left: 0;
  box-sizing: border-box;
  line-height: 18px;
  font-size: 13px;
}
</style>